var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#8DC351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3177 8.17647C14.753 6.76471 13.4118 6.69412 11.7883 6.97647L11.2236 5L10.0236 5.35294L10.5883 7.25882C10.3059 7.32941 9.953 7.47059 9.60006 7.54118L9.03536 5.56471L7.83536 5.91765L8.40006 7.89412C8.11771 7.96471 7.90594 8.03529 7.62359 8.10588L6.00006 8.67059L6.353 9.94118C6.353 9.94118 7.27065 9.65882 7.20006 9.65882C7.69418 9.51765 7.90594 9.72941 8.04712 10.0118L8.68241 12.2706C8.68241 12.2706 8.753 12.2706 8.82359 12.2706L8.68241 12.3412L9.60006 15.5176C9.60006 15.6588 9.60006 15.9412 9.24712 16.0824L8.40006 16.3647L8.54124 17.8471L10.0942 17.4235C10.3765 17.3529 10.6589 17.2824 10.9412 17.2118L11.5059 19.1882L12.7059 18.8353L12.1412 16.8588C12.4942 16.7882 12.7765 16.7176 13.1295 16.5765L13.6942 18.5529L14.8942 18.2L14.3295 16.2235C16.3059 15.5176 17.5765 14.6 17.2236 12.6235C16.9412 11.0706 16.0236 10.5765 14.753 10.6471C15.4589 9.94118 15.7412 9.23529 15.3177 8.17647ZM14.8942 12.9765C15.3177 14.4588 12.7059 15.0235 11.8589 15.3059L11.0824 12.6235C11.9295 12.4118 14.4001 11.4235 14.8942 12.9765ZM13.2001 9.37647C13.6236 10.7176 11.4354 11.2118 10.7295 11.4235L10.0236 9.02353C10.7295 8.81176 12.8471 7.96471 13.2001 9.37647Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBchIcon);
export default __webpack_public_path__ + "static/media/bch-icon.521994be.svg";
export { ForwardRef as ReactComponent };